"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchoEffectHandler = exports.EchoEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EffectType_1 = require("../EffectType");
class EchoEffectArgs {
    constructor(count) {
        this.count = count;
        this.__type = EffectType_1.EffectType.Echo;
        this.__typeName = "Echo";
        this.name = "Echo";
        this.harmful = false;
    }
}
exports.EchoEffectArgs = EchoEffectArgs;
let EchoEffectHandler = class EchoEffectHandler {
    apply(sequence, container, state) {
        state.meta.turnStartedEventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new __1.ApplyEffectEventHandlerArgs(state.creatorId, Target_1.Target.Self, Duration_1.Duration.Ticks(1), new _1.EchoStackEffectArgs(state.args.count)));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.turnStartedEventHandlerId);
    }
};
EchoEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Echo)
], EchoEffectHandler);
exports.EchoEffectHandler = EchoEffectHandler;
